import type { ComponentType } from 'react'
import type { SchemaType } from '../schemas'
import { ButtonRenderer } from './button'
import { CardRenderer } from './card'
import { DatePickerRenderer } from './date-picker'
import { DateRangeRenderer } from './date-range'
import { DescriptionsRenderer } from './desciptions'
import { FlexRenderer } from './flex'
import { FormRenderer } from './form'
import { InfiniteListRenderer } from './infinite-list'
import { InputNumberRenderer } from './input-number'
import { InputTextRenderer } from './input-text'
import { LinkRenderer } from './link'
import { QueryListRenderer } from './query-list'
import { SelectRenderer } from './select'
import { ServiceRenderer } from './service'
import { SpanRenderer } from './span'
import { TableRenderer } from './table'
import { ViewportRenderer } from './viewport'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rendererMap: Record<SchemaType, ComponentType<any>> = {
  button: ButtonRenderer,
  card: CardRenderer,
  'date-picker': DatePickerRenderer,
  'date-range': DateRangeRenderer,
  form: FormRenderer,
  'infinite-list': InfiniteListRenderer,
  'input-number': InputNumberRenderer,
  'input-text': InputTextRenderer,
  'query-list': QueryListRenderer,
  select: SelectRenderer,
  table: TableRenderer,
  viewport: ViewportRenderer,
  flex: FlexRenderer,
  link: LinkRenderer,
  span: SpanRenderer,
  service: ServiceRenderer,
  descriptions: DescriptionsRenderer,
}

export {
  ButtonRenderer,
  CardRenderer,
  DatePickerRenderer,
  DateRangeRenderer,
  FlexRenderer,
  FormRenderer,
  InputNumberRenderer,
  InputTextRenderer,
  LinkRenderer,
  QueryListRenderer,
  SelectRenderer,
  SpanRenderer,
  TableRenderer,
  ViewportRenderer,
}
